import React from 'react'

import {connect} from 'react-redux';


function UserDetails(props) {
  const person = props.data.reducer.details
  console.log(person)
  return (
    <div>
      <h1 id="userDetails">User Details</h1>

      <label>First Name: </label>
      <p id="firstName">{person.firstname ? person.firstname : "-"}</p><br />

      <label>Last Name: </label>
      <p id="lastName">{person.lastname ? person.lastname : "-"}</p><br />

      <label>Address1:</label>
      <p id="address1">{person.address1 ? person.address1 : "-"}</p><br />

      <label>Address2: </label>
      <p id="address2">{person.address2 ? person.address2 : "-"}</p><br />

      <label>City: </label>
      <p id="city">{person.city ? person.city : "-"}</p><br />

      <label>State: </label>
      <p id="state">{person.state ? person.state : "-"}</p><br />

      <label>Zip: </label>
      <p id="zip">{person.zip ? person.zip : "-"}</p><br />

      <label>Country: </label>
      <p id="country">{person.country ? person.country : "-"}</p><br />

      

    </div>
  )
}


const mapStateToProps = state => ({
  data: state
})

const mapDispatchToProps = dispatch => ({
    
})

export default connect(mapStateToProps,mapDispatchToProps)(UserDetails)

